import React from 'react'
import { useAppState } from 'Context/AppContext/AppContext'
import {
  UserSurveyPrimaryFunction,
  UserSurveyRole,
} from 'Generated/graphql-types'
import { ActionElementType } from 'Components/SharedComponents/Surveys/constants'
import {
  Description,
  Image,
  ImageContainer,
  StepContainer,
  Title,
} from 'Components/SharedComponents/Surveys/Surveys.styled'
import { NextActions } from 'Components/SharedComponents/Surveys/NextActions/NextActions'
import { ButtonAction } from 'Components/SharedComponents/Surveys/types'
import { HandleActionArgs } from '../../types'
import getStarted from '../../assets/getStarted.png'
import { NeedsAssessmentWizardStep } from '../../constants'
import { sendStepTransitionEvent } from '../../utils'

type GetStartedProps = {
  onAnyAction: ({ nextStep, callback }: HandleActionArgs) => void
  userPrimaryFunction: UserSurveyPrimaryFunction | undefined
  userJourneyLength: number
  userRole?: UserSurveyRole
}

export const GetStarted = ({
  onAnyAction,
  userPrimaryFunction,
  userJourneyLength,
  userRole,
}: GetStartedProps) => {
  const { nonprofitOrgConfig, userConfig } = useAppState()
  const { firstName } = userConfig
  const nextStep = NeedsAssessmentWizardStep.WHAT_IS_YOUR_ROLE
  const nextActions: ButtonAction[] = [
    {
      label: 'Get Started',
      path: nextStep,
      type: ActionElementType.BUTTON,
      callback: () => {
        sendStepTransitionEvent({
          currentStep: NeedsAssessmentWizardStep.GET_STARTED,
          nextStep,
          userId: userConfig.id,
          nonprofitOrgId: nonprofitOrgConfig.orgId,
          funderOrgId: nonprofitOrgConfig.funderOrgId,
          userEmail: userConfig.email,
          userPrimaryFunction,
          userJourneyLength,
          userRole,
        })
      },
    },
  ]

  return (
    <StepContainer>
      <Title>Get Started: Needs Assessment</Title>
      <Description>
        Resilia empowers those shaping the world – that’s you
        {firstName ? (
          <>
            , <strong>{firstName}</strong>
          </>
        ) : (
          ''
        )}
        !
        <br />
        <br />
        This 5-minute Needs Assessment helps us understand your priorities so we
        can offer tailored guidance and support for your organization’s impact
        journey.
      </Description>
      <ImageContainer>
        <Image src={getStarted} />
      </ImageContainer>
      <NextActions nextActions={nextActions} onAnyAction={onAnyAction} />
    </StepContainer>
  )
}
